import { render, staticRenderFns } from "./RecebimentoParcialModal.vue?vue&type=template&id=27ece23d"
import script from "./RecebimentoParcialModal.vue?vue&type=script&lang=js"
export * from "./RecebimentoParcialModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports